import React, { useState, useEffect, Fragment } from 'react';
import { Amount, Grid, Panel, Stat, GateKeeper, LazyBoi, Button } from '@components'
import { Asset } from '@archetypes'
import { ReactComponent as Refresh } from '@assets/Icon_Refresh.svg';
import assetController, { Status } from '@app/App.Controller'
import styled from "styled-components"
import { fromWei } from '@util/helpers'

import {
	WithdrawController,
} from './_controller'


const PresetsWrapper = styled.div`
    width: 50%; 
    margin-top: 10px;
    margin-bottom: 60px;
    height:  30px;

    button {
        font-size: 12px;
	}
	

`

export default ({ address, setExtensions }) => {
	const { balancer } = assetController

	// approval params
	const [approvalStatus, setApprovalStatus] = useState()
	const [approvalParams, setApprovalParams] = useState()
	const [controller, setController] = useState()
	const [withdrawParams, setWithdrawParams] = useState()

	useEffect(() => {
		const withdrawController = new WithdrawController(address, assetController)
		withdrawController.on('approvals', setApprovalParams)
		withdrawController.on('update', setWithdrawParams)
		setController(withdrawController)
		withdrawController.init()
		return () => withdrawController.cleanup()
	}, []) // eslint-disable-line

	useEffect(() => {
		if (withdrawParams && withdrawParams?.tx?.units !== "0") {
			let payload = []
			if (withdrawParams?.withdraw?.share) {
				payload.push({
					key: "Pool Share",
					value: <LazyBoi.Percent value={withdrawParams?.withdraw?.share} />
				})
			}
			if (withdrawParams?.withdraw?.value) {
				payload.push({
					key: "Value",
					value: <LazyBoi.Currency value={withdrawParams?.withdraw?.value} fromWei />
				})
			}
			if (withdrawParams?.withdraw?.units) {
				payload.push({
					key: "LP Tokens",
					value: <LazyBoi value={withdrawParams?.withdraw?.units} fromWei />
				})
			}
			setExtensions(payload)
		}
	}, [withdrawParams])

	const info = withdrawParams?.myUnits ? `Max : ${Number(fromWei(withdrawParams?.myUnits)).toLocaleString()} BPT` : ""

	return (<>
		<Panel>
			<GateKeeper
				controllerAssertions={[
					{
						controller: 'account',
						key: 'status',
						assert: val => val === Status.READY,
						onFail: 'Connect your wallet to start staking',
					}
				]}
				assertions={[
					{
						assert: () => !!withdrawParams,
						onFail: () => <Fragment><Refresh className='rotate' /> Fetching account info</Fragment>,
					},
					{
						assert: () => withdrawParams?.myUnits > 0,
						onFail: () => <Fragment>No assets in pool</Fragment>,
					}
				]}
				dependencies={[withdrawParams]}
			>

				{/* <Amount.Presets 
				title={`Select Amount`}
				onChange={pc => controller?.updateInputPercent(pc)}
			/>

			<Panel.Divider>
				<Asset.ContractApproval
					approvals={approvalParams}
					onUpdate={setApprovalStatus}
				/>
			</Panel.Divider>

			<Panel.Footer>
				<Panel.Footer.Group>
					<Grid cols={3}>
						<Stat title='Pool Units' small>
							<LazyBoi value={withdrawParams?.withdraw?.units} fromWei/>
						</Stat>
						<Stat title='Pool Share' small>
							<LazyBoi.Percent value={withdrawParams?.withdraw?.share}/>
						</Stat>
						<Stat title='Pool Value' small>
							<LazyBoi.Currency value={withdrawParams?.withdraw?.value} fromWei/>
						</Stat>
					</Grid>
				</Panel.Footer.Group>

				<Panel.Footer.Group>
					<Asset.ContractApproval.Button
						{...approvalStatus}
						onClick={() => {
							balancer.unstake(withdrawParams.address, withdrawParams.tx)
						}}
						>
						Withdraw from pool
					</Asset.ContractApproval.Button>
				</Panel.Footer.Group>
			</Panel.Footer> */}

				<Amount.GroupSelect
					className="group-input"
					info="I WANT TO WITHDRAW"
					infoEnd={info}
					min={0}
					value={withdrawParams?.inputAmount}
					onChange={amount => controller?.updateFromAmount(amount)}
					max={fromWei(withdrawParams?.myUnits)}
				/>
				<PresetsWrapper>
					<Amount.Presets
						// title={`I WANT TO WITHDRAW`}
						onChange={pc => controller?.updateInputPercent(pc)}
						value={withdrawParams?.inputPercent}
					/>
				</PresetsWrapper>
				<Button.Full
					disabled={withdrawParams?.tx?.units === "0"}
					style={{ width: "100%", height: "45px", marginTop: "20px" }}
					onClick={() => {
						balancer.unstake(withdrawParams.address, withdrawParams.tx)
					}}
				>
					Withdraw Liquidity
				</Button.Full>

			</GateKeeper>
		</Panel>
	</>)
}